import { ReceivedReviews } from '@/components/item-review/ReceivedReviews.tsx';

const ItemReviews = ({ primaryKey }: { primaryKey: string }) => (
    <div className="tw-absolute tw-bottom-20 tw-z-50 tw-max-h-[70vh] tw-w-full tw-bg-white tw-shadow-[0_-8px_24px_rgba(0,0,0,0.12)]">
        <div className="tw-max-h-[70vh] tw-overflow-y-auto tw-p-4">
            <ReceivedReviews primaryKey={primaryKey} />
        </div>
    </div>
);

export { ItemReviews };
